/**
@ngdoc directive
@name placeholder

@description
Placeholder fix for IE9 - it will just place the placeholder text underneath the field.
*/

(function() {
    'use strict';

    var placeholder = function() {
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            priority: -100, // needed for parent class check
            link: function(scope, element, attrs) {

                if (cssua.ua.ie <= 9.0) {

                    var strId = '';
                    if( angular.isDefined(attrs.id) && attrs.id!='' ) {
                        var id = attrs.id+'.placeholder';
                        strId = ' id="'+id+'"';
                        element.attr('aria-describedby', angular.isDefined(attrs.ariaDescribedby) ? attrs.ariaDescribedby+' '+id : id );
                    }
                    // var placeholderText = attrs.placeholder.slice(-1) == '.' ? attrs.placeholder : attrs.placeholder+'.'; // add dot at the end of
                    var hint = angular.element('<small'+strId+' class="text-muted placeholder-text">'+attrs.placeholder+'</small>');

                    var parent = element.parent();
                    if( parent.hasClass('input-group') || parent.hasClass('input-group-prepend') || parent.hasClass('spinner-input-box') ){
                        parent.after(hint)
                    } else {
                        element.after(hint);
                    }

                }
            }

        };
    }
    angular.module('app').directive('placeholder', placeholder);

}());